import styled from 'foundations-theming/utils';
import { OAuthToButtonBgColor, OAuthToButtonBorderColor, OAuthToButtonFontColor, OAuthToButtonHoverColor } from './OAuthMapping';
export const Root = styled.div.withConfig({
  displayName: "OAuthButtonstyles__Root",
  componentId: "s3vtc6-0"
})(["height:36px;margin:0 auto;max-width:420px;padding:0 1rem;width:100%;margin-top:24px;"]);
export const Button = styled.button.withConfig({
  displayName: "OAuthButtonstyles__Button",
  componentId: "s3vtc6-1"
})(["background:", ";border:2px solid ", ";border-radius:4px;color:", ";display:flex;align-items:center;justify-content:center;inline-size:100%;max-height:42px;height:42px;padding:0;&:disabled{background-color:", ";border-color:", ";color:", ";cursor:not-allowed;}&:hover{background-color:", ";}"], props => OAuthToButtonBgColor[props.oAuth], props => OAuthToButtonBorderColor[props.oAuth], props => OAuthToButtonFontColor[props.oAuth], ({
  theme
}) => theme.color['fill-secondary-disabled'], ({
  theme
}) => theme.color['border-secondary-disabled'], ({
  theme
}) => theme.color['text-secondary-disabled'], props => OAuthToButtonHoverColor[props.oAuth]);
export const Text = styled.span.withConfig({
  displayName: "OAuthButtonstyles__Text",
  componentId: "s3vtc6-2"
})(["display:flex;justify-content:center;align-items:center;width:100%;height:36px;font-size:14px;letter-spacing:0.25px;font-weight:500;min-width:160px;"]);
export const StyledOAuthErrorMessage = styled.div.withConfig({
  displayName: "OAuthButtonstyles__StyledOAuthErrorMessage",
  componentId: "s3vtc6-3"
})(["font-size:12px;text-align:center;margin-top:10px;color:#425b76;"]);